import { useContext } from "react";
import { ZustandSelector } from "src/types/zustand";
import { useStore } from "zustand";
import GatheringPublicFullContext from "../contexts/GatheringPublicFullContext";
import { GatheringPublicFullStore } from "../stores/gatheringPublicFullStore";

export const useGatheringPublicFullStore = <U extends any>(
	selector: ZustandSelector<GatheringPublicFullStore, U>,
): U => {
	const res = useContext(GatheringPublicFullContext);
	if (!res) {
		throw new Error(
			"useGatheringPreviewPublicStore must be used within a GatheringPreviewPublicProvider",
		);
	}
	return useStore(res.store, selector);
};
